import { render, staticRenderFns } from "./ListScheduleItems.vue?vue&type=template&id=3530ab61"
import script from "./ListScheduleItems.vue?vue&type=script&lang=js"
export * from "./ListScheduleItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports